<!-- @format -->

@if (studyTermLocators.length > 1) {
  <span>
    <sis-tooltip [appendToBody]="true" [tooltipBlockElement]="true">
      <sis-icon icon="info-circle" color="primary" class="sis-tooltip-trigger-content"></sis-icon>
      <div class="text-left sis-tooltip-content">
        @if (!isCustomStudyDraft) {
          <span translate>STUDENT_APPLICATIONS.EXTENSION_APPLICATION.COURSE_UNIT_TIMING_INFO</span>
        }
        @if (isCustomStudyDraft) {
          <span translate>STUDENT_APPLICATIONS.EXTENSION_APPLICATION.CUSTOM_STUDY_DRAFT_TIMING_INFO</span>
        }
        @for (locator of studyTermLocators; track locator; let isLast = $last) {
          <span>
            {{ (locator.termIndex === 0 ? "STUDY_TERMS.AUTUMN" : "STUDY_TERMS.SPRING") | translate }}
            {{ locator.studyYearStartYear + locator.termIndex }}{{ isLast ? "" : ", " }}
          </span>
        }
      </div>
    </sis-tooltip>
  </span>
}
